import useTranslate from 'modules/local/useTranslate'
import React, {useCallback} from 'react'
import {NullAsDefault} from 'views/Shared'
import _ from 'lodash'
import {SelectCountries} from '../../../Organization/Settings/SelectCountries'
import {SelectProvinces} from '../../../Organization/Settings/SelectProvinces'
import {useAppConfig} from '../../../../modules/local/AppConfigContext'
import {FilterStatusBar} from '../../../../components/Filters/FilterStatusBar'
import {SelectWidget} from '../../custom/ReactSelectComponents'
import {API_ROOT_URL} from '../../../../envs/_current/config'
import useAsync from '../../../../modules/asyncCache/useAsync'
import {SectionLabel} from './DirectoryFilterUI'

const defaultFilter = {
    keyword: undefined,
    country_id: undefined,
    province_id: undefined,
    hashtags: undefined,
}

export const DirectoryYellowPageFilter = ({
                                               value: filter = defaultFilter,
                                               onChange: setValues = NullAsDefault,
                                           }) => {
    const t = useTranslate()
    const {countries = [], provinces = []} = useAppConfig('countries', 'provinces')

    const {response} = useAsync({
        apiInfo: {
            root: API_ROOT_URL,
            path: '/lookup/yellow_page_hashtags/gets',
            method: 'GET',
            fields: ['keyword', 'country_id', 'province_id'],
        },
    })
    const hashtagOptions = _.get(response, 'data.data', [])

    const handleChange = useCallback(
        (name, value) => setValues({...filter, [name]: value}),
        [filter]
    )

    const filteredParams = Object.entries(filter)
        .filter(([, value]) => value != null)
        .map(([key, value]) => {
            switch (key) {
                case 'country_id':
                    return {key, value, displayValue: _.find(countries, {id: Number(value)})?.common_name}
                case 'province_id':
                    return {key, value, displayValue: _.find(provinces, {id: value})?.location_name}
                default:
                    return {key, value, displayValue: value}
            }
        })

    return (
        <div className="flex flex-col gap-3">
            <FilterStatusBar
                filteredParams={filteredParams}
                onClear={() => setValues(defaultFilter)}
                onRemove={(param) => handleChange(param, undefined)}
            />

            <div className="flex flex-col gap-1">
                <SectionLabel>{t('country')}</SectionLabel>
                <SelectCountries
                    value={filter?.country_id || undefined}
                    allowClear={true}
                    onChange={(value) => handleChange('country_id', Number(value) || undefined)}
                    placeholder={t('click to select')}
                />
            </div>

            <div className="flex flex-col gap-1">
                <SectionLabel>{t('province')}</SectionLabel>
                <SelectProvinces
                    value={filter?.province_id}
                    allowClear={true}
                    onChange={(value) => handleChange('province_id', Number(value) || undefined)}
                    placeholder={t('click to select')}
                />
            </div>

            {
                hashtagOptions?.length > 0 && (
                    <div className="flex flex-col gap-1">
                        <SectionLabel>{t('category tags')}</SectionLabel>
                        <SelectWidget
                            className="w-full"
                            value={filter?.hashtags || undefined}
                            allowClear={true}
                            placeholder={t('click to select')}
                            onChange={(value) => handleChange('hashtags', value)}
                            options={hashtagOptions.map((e) => ({key: 'hashtags.' + e?.name, value: e?.name, label: e?.name}))}
                        />
                    </div>
                )
            }
        </div>
    )
}

export default DirectoryYellowPageFilter
